import React from 'react';
import { DialogContent, DialogTitle } from '../shared/Dialog';
import { Ticket, TicketStatus } from '@/lib/OrderApi';
import { DialogClose } from '@radix-ui/react-dialog';
import AvailableTicket from './AvailableTicket';
import { timeSlotLabel } from '@/lib/timeSlot';
import { useLanguage } from '@/providers/LanguageProvider';
import * as m from "@/paraglide/messages.js"

interface ScanOrDownloadTicketModalProps {
    ticket: Ticket,
}

const ScanOrDownloadTicketModal: React.FC<ScanOrDownloadTicketModalProps> = ({ticket}) => {
  const { currentLanguage: lang } = useLanguage();

  return (
      <DialogContent className='bg-[var(--shop-panelBackgroundColor)] text-[var(--shop-textColor)]'>
        <DialogTitle className='text-center mx-auto'>{ticket.productName} <span className='text-xs tracking-tight'> {ticket.numberOfProductType}/{ticket.totalOfProductType}</span></DialogTitle>
        {/* FAS-1053 — repeated here: the QR only lets its holder in during this slot */}
        {ticket.timeSlot && (
          <p className='text-center mx-auto text-sm font-semibold'>{timeSlotLabel(ticket.timeSlot, lang)}</p>
        )}
        {ticket.ticketStatus === TicketStatus.available && (<AvailableTicket ticket={ticket} />)}
        <DialogClose asChild>
                <button className='bg-[var(--shop-ctaButtonColor)] text-[var(--shop-ctaButtonTextColor)] p-2 rounded-md text-center block w-full hover:opacity-90 transition-all duration-300 hover:shadow-md mt-4'>
                    {m.close()}
                </button>
            </DialogClose>
      </DialogContent>
  );
};

export default ScanOrDownloadTicketModal;
